import { injecterStyles } from './styles'

export type MethodeConnexion = 'whatsapp' | 'email'

/**
 * Choix « Numéro WhatsApp | E-mail (recommandé) » en tête d'un formulaire de connexion ou de création.
 * L'e-mail reste proposé et encouragé, jamais obligatoire. Onglets accessibles (flèches gauche/droite).
 */
export function BasculeMethode({
  methode,
  surChangement,
  desactive = false,
}: {
  methode: MethodeConnexion
  surChangement: (m: MethodeConnexion) => void
  desactive?: boolean
}) {
  injecterStyles()
  const options: { m: MethodeConnexion; libelle: string }[] = [
    { m: 'whatsapp', libelle: 'Numéro WhatsApp' },
    { m: 'email', libelle: 'E-mail (recommandé)' },
  ]
  return (
    <div
      className="cw-bascule"
      role="tablist"
      aria-label="Méthode de connexion"
      onKeyDown={(e) => {
        if (desactive || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return
        e.preventDefault()
        surChangement(methode === 'whatsapp' ? 'email' : 'whatsapp')
      }}
    >
      {options.map((o) => (
        <button
          key={o.m}
          type="button"
          role="tab"
          aria-selected={methode === o.m}
          tabIndex={methode === o.m ? 0 : -1}
          disabled={desactive}
          onClick={() => surChangement(o.m)}
        >
          {o.libelle}
        </button>
      ))}
    </div>
  )
}
